import type { IconSvgObject } from './types';

const SigmaIcon: IconSvgObject = [
  ["path", { d: "M18.4922 6.5V6C18.4922 4.58579 18.4922 3.87868 18.0208 3.43934C17.5495 3 16.7909 3 15.2736 3H10.6394C7.556 3 6.01431 3 5.58768 3.88552C5.16105 4.77103 6.18529 5.84505 8.23379 7.99309L10.1543 10.0069C11.0588 10.9554 11.5111 11.4297 11.5111 12C11.5111 12.5703 11.0588 13.0446 10.1543 13.9931L8.23379 16.0069C6.18529 18.1549 5.16105 19.229 5.58768 20.1145C6.01431 21 7.556 21 10.6394 21H15.2736C16.7909 21 17.5495 21 18.0208 20.5607C18.4922 20.1213 18.4922 19.4142 18.4922 18V17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SigmaIcon;
